// import { useState } from "react";
import { FiX } from "react-icons/fi";
import AddToCartContent from "./AddToCartContent";
import RemoveContent from "./RemoveContent";

const WishlistModal = ({ modalData, onClose, onAddToCart, onRemove }) => {
  if (!modalData) return null;

  const { type, product } = modalData;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 px-4">
      <div className="bg-white w-full max-w-2xl rounded-2xl p-6 relative shadow-xl">

        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-600 hover:text-black"
        >
          <FiX size={22} />
        </button>

        {type === "add" ? (
          <AddToCartContent
            product={product}
            onAddToCart={onAddToCart}
            onClose={onClose}
          />
        ) : (
          <RemoveContent
            product={product}
            onRemove={onRemove}
            onAddToCart={onAddToCart}
            onClose={onClose}
          />
        )}
      </div>
    </div>
  );
};

export default WishlistModal;